export function getCountry(int) {
  return countries[int % countries.length]
}

export function getCity(int) {
  return cities[int % cities.length]
}

export function getPlace(int) {
  return places[int % places.length]
}

const countries = [
  "Luxemburg",
  "Noorwegen",
  "Zwitserland",
  "Cyprus",
  "Denemarken",
  "Nederland",
  "Ierland",
  "Verenigde Staten",
  "Oostenrijk",
  "Australië",
  "Zweden",
  "België",
  "Finland",
  "Frankrijk",
  "Duitsland",
  "Verenigde Arabische Emiraten",
  "Japan",
  "Canada",
  "IJsland",
  "Singapore",
  "Italië",
  "Verenigd Koninkrijk",
  "Spanje",
  "Koeweit",
  "Griekenland",
  "Nieuw-Zeeland",
  "Israël",
  "Brunei",
  "Qatar",
  "Slovenië",
  "Bahama's",
  "Portugal",
  "Bahrein",
  "Malta",
  "Tsjechië",
  "Oman",
  "Zuid-Korea",
  "Taiwan",
  "Slowakije",
  "Trinidad en Tobago",
  "Saoedi-Arabië",
  "Estland",
  "Kroatië",
  "Antigua en Barbuda",
  "Barbados",
  "Hongarije",
  "Venezuela",
  "Letland",
  "Polen",
  "Litouwen",
  "Saint Kitts en Nevis",
  "Equatoriaal-Guinea",
  "Libië",
  "Chili",
  "Uruguay",
  "Seychellen",
  "Turkije",
  "Libanon",
  "Rusland",
  "Brazilië",
  "Mexico",
  "Argentinië",
  "Roemenië",
  "Gabon",
  "Panama",
  "Kazachstan",
  "Maleisië",
  "Mauritius",
  "Botswana",
  "Costa Rica",
  "Bulgarije",
  "Grenada",
  "Zuid-Afrika",
  "Servië",
  "Suriname",
  "Saint Lucia",
  "Saint Vincent en de Grenadines",
  "Dominicaanse Republiek",
  "Wit-Rusland",
  "Colombia",
  "Dominica",
  "Azerbeidzjan",
  "Namibië",
  "Noord-Macedonië",
  "Iran",
  "Marokko",
  "Jamaica",
  "Peru",
  "Bosnië en Herzegovina",
  "Ecuador",
  "Belize",
  "Algerije",
  "Angola",
  "Thailand",
  "Maldiven",
  "Tunesië",
  "Jordanië",
  "Albanië",
  "China",
  "El Salvador",
  "Fiji",
  "Kaapverdië",
  "Turkmenistan",
  "Samoa",
  "Tonga",
  "Swaziland",
  "Armenië",
  "Guatemala",
  "Vanuatu",
  "Ghana",
  "Syrië",
  "Oekraïne",
  "Congo-Brazzaville",
  "Egypte",
  "Georgië",
  "Paraguay",
  "Indonesië",
  "Irak",
  "Sri Lanka",
  "Bhutan",
  "Honduras",
  "Filipijnen",
  "Bolivia",
  "Mongolië",
  "Moldavië",
  "Soedan",
  "Djibouti",
  "Kiribati",
  "Nieuw-Guinea",
  "Salomonseilanden",
  "Oezbekistan",
  "Sao Tomé en Principe",
  "Nigeria",
  "Kameroen",
  "Zambia",
  "Jemen",
  "Vietnam",
  "Ivoorkust",
  "India",
  "Pakistan",
  "Senegal",
  "Mauritanië",
  "Nicaragua",
  "Kenia",
  "Laos",
  "Kirgizië",
  "Comoren",
  "Cambodja",
  "Tadzjikistan",
  "Haïti",
  "Benin",
  "Tsjaad",
  "Ghana",
  "Mali",
  "Lesotho",
  "Bangladesh",
  "Burkina Faso",
  "Tanzania",
  "Oost-Timor",
  "Rwanda",
  "Guinee-Bissau",
  "Afghanistan",
  "Oeganda",
  "Mozambique",
  "Myanmar",
  "Nepal",
  "Centraal-Afrikaanse Republiek",
  "Gambia",
  "Togo",
  "Guinee",
  "Madagaskar",
  "Ethiopië",
  "Zimbabwe",
  "Niger",
  "Eritrea",
  "Malawi",
  "Sierra Leone",
  "Liberia",
  "Congo-Kinshasa",
  "Burundi",
]

const cities = [
  "Guangzhou",
  "Shanghai",
  "Tokio",
  "Delhi",
  "Jakarta",
  "Manilla",
  "Mumbai",
  "Mexico-Stad",
  "Seoel",
  "Dhaka",
  "Caïro",
  "São Paulo",
  "Bangkok",
  "New York",
  "Beijing",
  "Lagos",
  "Karachi",
  "Moskou",
  "Chengdu",
  "Kolkata",
  "Osaka",
  "Quanzhou",
  "Los Angeles",
  "Buenos Aires",
  "Teheran",
  "Kinshasa",
  "Istanbul",
  "Londen",
  "Johannesburg",
  "Bangalore",
  "Hangzhou",
  "Lahore",
  "Ho Chi Minhstad",
  "Rio de Janeiro",
  "Xi'an",
  "Chennai",
  "Chongqing",
  "Wuhan",
  "Lima",
  "Haiderabad",
  "Tianjin",
  "Shantou",
  "Changsha",
  "Parijs",
  "Rijn-Ruhrgebied",
  "Bogota",
  "Nagoya",
  "Zhengzhou",
  "Taipei",
  "Ahmedabad",
  "Luanda",
  "Chicago",
  "Kuala Lumpur",
  "Nanjing",
  "Shenyang",
  "Washington",
  "Santiago",
  "Hefei",
  "Surat",
  "Pune",
  "Singapore",
  "Toronto",
  "Bagdad",
  "Dallas",
  "Boston",
  "Riyad",
  "Qingdao",
  "Ningbo",
  "Hongkong",
  "Philadelphia",
  "San Francisco",
  "Hanoi",
  "Houston",
  "Khartoem",
  "Abidjan",
  "Bandung",
  "Wenzhou",
  "Nairobi",
  "Accra",
  "Kunming",
  "Jinan",
  "Madrid",
  "Dar es Salaam",
  "Shijiazhuang",
  "Sint-Petersburg",
  "Miami",
  "Alexandrië",
  "Amman",
  "Atlanta",
  "Milaan",
  "Monterrey",
  "Taiyuan",
  "Manchester",
  "Dubai",
  "Guadalajara",
  "Surabaya",
  "Detroit",
  "Bamako",
  "Yangon",
  "Rawalpindi",
  "Harbin",
  "Nanning",
  "Dalian",
  "Kano",
  "Belo Horizonte",
  "Guiyang",
  "Kabul",
  "Ankara",
  "Changchun",
  "Melbourne",
  "Nanchang",
  "Sydney",
  "Kaapstad",
  "Koeweit-Stad",
  "Chittagong",
  "Tampa",
  "Ürümqi",
  "Colombo",
  "Phoenix",
  "Barcelona",
  "Addis Abeba",
  "Fuzhou",
  "Berlijn",
  "Linyi",
  "Jaipur",
  "Montréal",
  "Seattle",
  "Casablanca",
  "Medellín",
  "Algiers",
  "Kampala",
  "Puebla",
  "Medan",
  "Dakar",
  "Lucknow",
  "Faisalabad",
  "Recife",
  "Napels",
  "Birmingham",
  "Busan",
  "Damascus",
  "Yaoundé",
  "Zibo",
  "Jeddah",
  "Porto Alegre",
  "Douala",
  "Durban",
  "Santo Domingo",
  "Denver",
  "Orlando",
  "Brasilia",
  "Caracas",
  "Tasjkent",
  "Fortaleza",
  "Indore",
  "Luoyang",
  "Bakoe",
  "Kanpur",
  "Athene",
  "Lanzhou",
  "Nagpur",
  "Kiev",
  "Mashhad",
  "Nantong",
  "Brisbane",
  "Gujranwala",
  "Rotterdam",
  "Isfahan",
  "Ouagadougou",
  "Rome",
  "Ibadan",
  "Salvador",
  "Bhilai",
  "Guatemala-Stad",
  "Curitiba",
  "Guayaquil",
  "Weifang",
  "Sanaa",
  "Campinas",
  "Frankfurt am Main",
  "Minneapolis",
  "Jiangyin",
  "San Diego",
  "Kathmandu",
  "Vancouver",
  "Antananarivo",
  "Xuzhou",
  "Coimbatore",
  "Abuja",
  "Cleveland",
  "Port-au-Prince",
  "Izmir",
  "Pyongyang",
  "Lusaka",
  "Tel Aviv-Jaffa",
]

const places = [
  "Dongguan",
  "Foshan",
  "Huizhou",
  "Jiangmen",
  "Shenzhen",
  "Zhongshan",
  "Changshu",
  "Changzhou",
  "Kunshan",
  "Suzhou",
  "Wuxi",
  "Chiba",
  "Funabashi",
  "Hachioji",
  "Kawaguchi",
  "Kawasaki",
  "Maebashi",
  "Sagamihara",
  "Saitama",
  "Utsunomiya",
  "Yokohama",
  "Faridabad",
  "Ghaziabad",
  "Gurgaon",
  "Loni",
  "New Delhi",
  "Noida",
  "Bekasi",
  "Bogor",
  "Depok",
  "Tangerang",
  "Antipolo",
  "Calamba",
  "Caloocan",
  "Dasmariñas",
  "Parañaque",
  "Pasig",
  "Quezon City",
  "San Jose del Monte",
  "Taguig",
  "Valenzuela",
  "Bhiwandi",
  "Kalyan-Dombivli",
  "Mira-Bhayandar",
  "Navi Mumbai",
  "Thane",
  "Vasai-Virar",
  "Chimalhuacán",
  "Ciudad López Mateos",
  "Cuautitlán Izcalli",
  "Ecatepec",
  "Nezahualcóyotl",
  "Naucalpan",
  "Tlalnepantla",
  "Ansan",
  "Anyang",
  "Bucheon",
  "Goyang",
  "Incheon",
  "Namyangju",
  "Seongnam",
  "Siheung",
  "Suwon",
  "Gazipur",
  "Narayanganj",
  "Savar",
  "Gizeh",
  "Helwan",
  "Shubra El Khema",
  "Guarulhos",
  "Osasco",
  "Santo André",
  "São Bernardo do Campo",
  "Nakhon Pathom",
  "Nonthaburi",
  "Samut Prakan",
  "Jersey City",
  "Newark",
  "New Haven",
  "Paterson",
  "Yonkers",
  "Ogun",
  "Balasjicha",
  "Chimki",
  "Podolsk",
  "Deyang",
  "Haora",
  "Himeji",
  "Kobe",
  "Kyoto",
  "Sakai",
  "Longhai",
  "Putian",
  "Xiamen",
  "Zhangzhou",
  "Anaheim",
  "Long Beach",
  "Santa Ana",
  "Inland Empire (Riverside",
  "San Bernardino)",
  "La Plata",
  "Lomas de Zamora",
  "Merlo",
  "Quilmes",
  "San Justo",
  "Karaj",
  "Gebze",
  "Reading",
  "Southend-on-Sea",
  "Watford",
  "Oost-Rand",
  "Pretoria",
  "Soweto",
  "West Rand",
  "Vereeniging",
  "Shaoxing",
  "Sheikhupura",
  "Biên Hòa",
  "Thuận An",
  "Belford Roxo",
  "Duque de Caxias",
  "Niterói",
  "Nova Iguaçu",
  "São Gonçalo",
  "Xianyang",
  "Bishan",
  "Jiangjin",
  "Callao",
  "Chaozhou",
  "Jieyang",
  "Puning",
  "Xiangtan",
  "Zhuzhou",
  "Saint Denis",
  "Versailles",
  "Évry",
  "Bonn",
  "Dortmund",
  "Duisburg",
  "Düsseldorf",
  "Essen",
  "Keulen",
  "Soacha",
  "Gifu",
  "Okazaki",
  "Yokkaichi",
  "Xingyang",
  "Xinmi",
  "Zhongmou",
  "Taoyuan",
  "Nieuw Taipei",
  "Elgin",
  "Joliet",
  "Naperville",
  "Klang",
  "Petaling Jaya",
  "Subang Jaya",
  "Ma'anshan",
  "Fushun",
  "Arlington",
  "Baltimore",
  "Puente Alto",
  "Feidong",
  "Feixi",
  "Pimpri-Chinchwad",
  "Johor Bahru",
  "Brampton",
  "Hamilton",
  "Kitchener",
  "Mississauga",
  "Arlington",
  "Fort Worth",
  "Brockton",
  "Cambridge",
  "Providence",
  "Jiaozhou",
  "Cixi",
  "Yuyao",
  "Kowloon",
  "Victoria",
  "Allentown",
  "Trenton",
  "Concord",
  "Oakland",
  "San José",
  "Santa Rosa",
  "The Woodlands",
  "Sugar Land",
  "Omdurman",
  "Cimahi",
  "Rui'an",
  "Yueqing",
  "Getafe",
  "Parla",
  "Fort Lauderdale",
  "West Palm Beach",
  "Zarka",
  "Alpharetta",
  "Sandy Springs",
  "Bergamo",
  "Como",
  "Monza",
  "Apodaca",
  "Guadalupe",
  "Jinzhong",
  "Blackburn",
  "Liverpool",
  "Warrington",
  "Ajman",
  "Sharjah",
  "Tlaquepaque",
  "Zapopan",
  "Toledo",
  "Windsor",
  "Islamabad",
  "Contagem",
  "Paarl",
  "Somerset West",
  "Lakeland",
  "Saint Petersburg",
  "Spring Hill",
  "Dehiwala-Mount Lavinia",
  "Negombo",
  "Glendale",
  "Mesa",
  "Terrassa",
  "Sabadell",
  "Minhou",
  "Potsdam",
  "Laval",
  "Saint-Jean-sur-Richelieu",
  "Everett",
  "Tacoma",
  "Bello",
  "Blida",
  "Jaboatão dos Guararapes",
  "Caserta",
  "Giugliano in Campania",
  "Coventry",
  "Gimhae",
  "Zouping",
  "Gravataí",
  "Novo Hamburgo",
  "Los Alcarrizos",
  "Aurora",
  "Lakewood",
  "Kissimmee",
  "Sanford",
  "Baruta",
  "Los Teques",
  "Caucaia",
  "Piraeus",
  "Gold Coast",
  "Sunshine Coast",
  "Den Haag",
  "Camaçari",
  "Raipur",
  "Villa Nueva",
  "São José dos Pinhais",
  "Shouguang",
  "Wiesbaden",
  "Mainz",
  "Darmstadt",
  "Saint Paul",
  "Chula Vista",
  "Oceanside",
  "Abbotsford",
  "Victoria",
  "Akron",
]
